import React from 'react'
import styled from '@emotion/styled'
import ArrowButton from './arrow-button'

const Container = styled.div`
  display: flex;
`

const NextButton = styled(ArrowButton)``

const PrevButton = styled(ArrowButton)`
  transform: rotate(180deg);
  margin-right: ${p => p.theme.space[3]};
`

const Navigation = ({
  canScrollPrev,
  canScrollNext,
  onScrollToPrev,
  onScrollToNext,
  variant,
  className,
}) => (
  <Container className={className}>
    <PrevButton
      variant={variant}
      onClick={onScrollToPrev}
      disabled={!canScrollPrev}
      aria-label="Scroll to previous slide"
    />
    <NextButton
      variant={variant}
      onClick={onScrollToNext}
      disabled={!canScrollNext}
      aria-label="Scroll to next slide"
    />
  </Container>
)

export default Navigation
